/**
 *  登陆相关mixins
 * */
export default {
	data() {
		return {

		}
	},
	methods: {
		/**
		 * 登陆
		 */
		_doLogin(loginForm) {

		},
		/**
		 *  获取个人信息
		 * */
		_getUserInfo() {

		},
		/**
		 *  获取个人权限列表
		 * */
		_getUserPerMision(callback) {

		},
		/**
		 * 登陆失败
		 */
		_loginFailed(){

		},
		/**
		 * 退出登录
		 */
		_logout() {
			this.$api.logout().then(res => {
				this.$store.commit('UPDATE_OAUTH', {})
				this._linkToLogout();
			})
		},
		_linkToLogout(){
			this.$router.push({path: '/login'})
		},
	}
}
